export class UnitUtils {
  static ptToPx(pt: number) {
    return (pt * 100) / 75;
  }

  static pxToPt(px: number) {
    return (px / 100) * 75;
  }
}
